import React from 'react';
import { Star, Package, Award, Waves, HeadphonesIcon, BadgeCheck } from 'lucide-react';
import { whyChooseUs } from '../mockData';

const iconMap = {
  Star: Star,
  Package: Package,
  Award: Award,
  Waves: Waves,
  HeadphonesIcon: HeadphonesIcon,
  BadgeCheck: BadgeCheck,
};

const WhyChooseUs = () => {
  return (
    <section id="why-us" className="py-24 bg-white relative">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <div className="text-cyan-800 text-sm font-semibold tracking-wider uppercase mb-4">
            WHY CHOOSE US
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            The Pro Cinemax Advantage
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            Pioneers in Premium Home Theatre Solutions & Immersive Cinema Experiences
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {whyChooseUs.map((item) => {
            const IconComponent = iconMap[item.icon] || Star;
            return (
              <div
                key={item.id}
                className="group relative bg-gradient-to-br from-cyan-50 to-white rounded-2xl p-8 border border-cyan-100 hover:border-cyan-300 hover:shadow-xl transition-all duration-300"
              >
                {/* Icon */}
                <div className="w-14 h-14 bg-cyan-800 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-cyan-800/30">
                  <IconComponent className="w-7 h-7 text-white" />
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-cyan-800 transition-colors">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {item.description}
                </p>

                {/* Decorative Corner */}
                <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-cyan-100 to-transparent rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
